<div class="overflow-hidden" #breadcrumbContainer>
  <p-breadcrumb [home]="home" [model]="displayedBreadcrumbs()">
    <ng-template #item let-item>
      @if (item.label === '...') {
        <span
          (mouseenter)="showOverlay($event)"
          class="ellipsis-item text-sm md:text-base font-bold px-2 select-none">
          {{ item.label }}
        </span>
      } @else if (item.routerLink.length >0 && item.routerLink != null && item.routerLink != undefined) {
        <a [routerLink]="item.routerLink" (click)="popover.hide()">
          <p [title]="item.title?(item.title | translate ) : ''"
            class="hover:text-red-500 text-sm md:text-base whitespace-nowrap">
            <i [class]="item.icon" class="text-sm md:text-base "></i>
            {{ item.title | translate }}
          </p>
        </a>
      } @else {
        <p [title]="item.title?(item.title | translate ) : ''"
          class="text-sm md:text-base whitespace-nowrap">
          {{ item.title | translate }}
        </p>
      }
    </ng-template>
  </p-breadcrumb>

  <p-popover #popover (onHide)="onOverlayHide()">
    <div class="flex flex-col gap-2 min-w-[200px]" (mouseenter)="keepOverlayOpen()" (mouseleave)="hideOverlay()">
      @for (item of hiddenItems(); track item) {
        @if (item.routerLink.length >0 && item.routerLink != null && item.routerLink != undefined) {
          <a
            class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded transition-colors"
            [routerLink]="item.routerLink" (click)="popover.hide()">
            <span class="text-sm">{{  ''+item.title | translate }}</span>
          </a>
        }@else {
          <div class="hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded transition-colors"  (click)="popover.hide()">
            <span class="text-sm">{{  ''+item.title | translate }}</span>
            </div>
        }
      }
    </div>
  </p-popover>
